angular.module('impactx.util').directive('ixHint', function () {
    return {
        restrict: 'E',
        template: '<div class="ix-hint">{{text}}</div>',
        scope: {
            text: "@"
        }
    }
});